import { View, Text, styled } from 'tamagui'
import { Shield } from '@tamagui/lucide-icons'
import { Avatar, StatusDot } from '../../common'
import type { User } from '@/types'

const Header = styled(View, {
  height: 48,
  paddingHorizontal: 16,
  flexDirection: 'row',
  alignItems: 'center',
  gap: 10,
  borderBottomWidth: 1,
  borderBottomColor: '$borderDefault',
  backgroundColor: '$surface',
})

const Name = styled(Text, {
  fontFamily: '$fontBody',
  fontWeight: '600',
  fontSize: 15,
  color: '$surfaceForeground',
})

const StatusText = styled(Text, {
  fontFamily: '$fontBody',
  fontSize: 12,
  color: '$sidebarMuted',
  marginLeft: 4,
})

interface DMHeaderProps {
  user: User
}

export function DMHeader({ user }: DMHeaderProps) {
  return (
    <Header>
      <Avatar name={user.displayName} color={user.roleColor || '#8B95A8'} status={user.status} size="md" />
      <Name>{user.displayName}</Name>
      <StatusDot status={user.status} size={8} />
      <StatusText>{user.status}</StatusText>
      <View flex={1} />
      <View flexDirection="row" alignItems="center" gap={4} backgroundColor="$accentLighter" borderRadius={4} paddingHorizontal={8} paddingVertical={3} borderWidth={1} borderColor="$accent">
        <Shield size={12} color="$accent" />
        <Text fontFamily="$fontMono" fontSize={11} fontWeight="600" color="$accent">E2E</Text>
      </View>
    </Header>
  )
}
